import ApiClient from "@/api/ApiClient.ts";
import { sortByKeyValueNumeric } from "@/utils/sorters";
import qs from "qs";

const state = {
  taxis: [],
  taxiById: {},
  driversTaxiById: [],
  reqs: null,
};

const mutations = {
  setTaxis(state, taxis) {
    state.taxis = taxis;
  },

  setTaxiById(state, taxi) {
    state.taxiById = taxi;
  },

  setDriversTaxiById(state, drivers) {
    state.driversTaxiById = drivers;
  },

  setReqs: (state, reqs) => {
    state.reqs = reqs;
  },
};

const actions = {
  async getTaxis({ commit }, payload) {
    let params = {};
    if (payload) {
      params = {
        wgId: payload.params.wgId,
        centralId: payload.params.centralId,
        output: payload.params.output || "opTaxiAdminData",
      };
    }
    try {
      let response = await ApiClient().get("taxis2", {
        params,
      });
      commit("setTaxis", response.data.sort(sortByKeyValueNumeric("license")));
    } catch (error) {
      console.error("ERROR en getTaxis: ", error.message);
    }
  },

  async getTaxiById({ commit }, payload) {
    const params = {
      output: "opTaxiAdminData",
      ...payload.params,
    };
    try {
      let { data } = await ApiClient().get("taxis2", {
        params,
      });
      data.sanctionData = Object.assign({}, data.sanctionData || {});
      if (
        !Number.isInteger(data.sanctionData?.sanctionFrom) ||
        data.sanctionData?.sanctionFrom === 0
      ) {
        data.sanctionData.sanctionFrom = null;
      } else {
        data.sanctionData.sanctionFrom *= 1000;
      }
      if (!Number.isInteger(data.sanctionData?.sanctionTo) || data.sanctionData?.sanctionTo === 0) {
        data.sanctionData.sanctionTo = null;
      } else {
        data.sanctionData.sanctionTo *= 1000;
      }
      if (!data.sanctionData.appliedSanction || data.sanctionData?.appliedSanction === 0) {
        data.sanctionData.appliedSanction = 1;
      }
      if (!data.btConfig) {
        data.btConfig = {
          btEnable: false,
          version: "",
        };
      }
      if (payload.hasToReturnData) {
        return data;
      } else {
        commit("setTaxiById", data);
      }
    } catch (error) {
      console.error("ERROR en getTaxiById: ", error.message);
    }
  },

  async getTaxiLog(_, payload) {
    const params = {
      ...payload.params,
    };
    try {
      let { data } = await ApiClient({ timeout: 300000 }).get("taxis2/log", {
        params,
      });
      if (data.lines && data.lines.length) {
        data.lines = data.lines.map((line, i) => {
          let event = data.selectsFormsFieldsOptions.eventFilterOptions.find(
            (e) => e.value === line.event
          );
          line.event = event;
          return {
            id: Math.floor(Math.random() * 10000),
            order: i + 1,
            ...line,
          };
        });
      }
      if (data.route && data.route.length) {
        let latlngs = [];
        data.route.forEach((p) => {
          let pointLatLngs = [];
          pointLatLngs.push(p.lat, p.lng);
          latlngs.push(pointLatLngs);
        });
        data.route.latlngs = latlngs;
      }
      return data;
    } catch (error) {
      console.error("ERROR en getTaxiLogs: ", error.message);
      throw error;
    }
  },

  async createTaxi(_, payload) {
    const params = {
      ...payload.params,
    };
    try {
      await ApiClient().post("taxis2", null, {
        params,
      });
      return true;
    } catch (error) {
      console.error("ERROR en createTaxi: ", error.message);
      return false;
    }
  },

  async updateTaxi(_, payload) {
    let taxiToUpdate = JSON.parse(JSON.stringify(payload.data));
    if (taxiToUpdate.sanctionData.sanctionFrom) {
      taxiToUpdate.sanctionData.sanctionFrom = Math.floor(
        taxiToUpdate.sanctionData.sanctionFrom / 1000
      );
    }
    if (taxiToUpdate.sanctionData.sanctionTo) {
      taxiToUpdate.sanctionData.sanctionTo = Math.floor(
        taxiToUpdate.sanctionData.sanctionTo / 1000
      );
    }
    const params = {
      ...payload.params,
    };
    try {
      await ApiClient().put("taxis2", taxiToUpdate, {
        params,
      });
      return true;
    } catch (error) {
      console.error("ERROR en updateTaxi: ", error.message);
      throw error;
    }
  },

  async deleteTaxi(_, payload) {
    const params = {
      ...payload.params,
    };

    try {
      await ApiClient().delete("taxis2", {
        params,
      });
      return true;
    } catch (error) {
      console.error("ERROR en deleteTaxi: ", error.message);
      return false;
    }
  },

  async relocateTaxi(_, payload) {
    const data = {
      stopId: payload.data.stopSelected,
      stopPosition: payload.data.stopPosition,
    };
    const params = {
      ...payload.params,
    };
    try {
      const api = ApiClient();
      await api.put("taxis/relocate", data, {
        params,
      });
    } catch (error) {
      console.error("ERROR en relocateTaxi: ", error.message);
    }
  },

  async ejectTaxi(_, payload) {
    const params = {
      ...payload.params,
    };
    try {
      await ApiClient().put("taxis/eject", null, {
        params,
      });
      return true;
    } catch (error) {
      console.error("ERROR en ejectTaxi: ", error.message);
      return false;
    }
  },

  // old
  async openCanalTaxis(_, payload) {
    const data = {
      radioOn: 1,
    };
    const params = {
      ...payload.params,
    };
    const urlFormData = qs.stringify(data);
    try {
      const api = ApiClient();
      await api.put("taxis/radio", urlFormData, {
        params,
        headers: {
          "content-type": "application/x-www-form-urlencoded",
        },
      });
    } catch (error) {
      console.error("ERROR en openCanalTaxis: ", error.message);
    }
  },

  async getDriversTaxi({ commit }, payload) {
    const params = {
      ...payload.params,
    };
    try {
      let { data } = await ApiClient().get("taxis2/driver", {
        params,
      });
      commit("setDriversTaxiById", data);
    } catch (error) {
      console.error("ERROR en getTaxiById: ", error.message);
    }
  },

  async createDriverTaxi(_, payload) {
    const params = {
      ...payload.params,
    };

    try {
      await ApiClient().post("taxis2/driver", payload.data, {
        params,
      });
      return true;
    } catch (error) {
      console.error("ERROR en createDriverTaxi: ", error.message);
      return false;
    }
  },

  async updateDriverTaxi(_, payload) {
    const params = {
      ...payload.params,
    };
    try {
      await ApiClient().put("taxis2/driver", payload.data, {
        params,
      });
      return true;
    } catch (error) {
      console.error("ERROR en updateDriverTaxi: ", error.message);
      return false;
    }
  },

  async deleteDriverTaxi(_, paramsUrl) {
    const params = {
      ...paramsUrl,
    };

    try {
      await ApiClient().delete("taxis2/driver", {
        params,
      });
      return true;
    } catch (error) {
      console.error("ERROR en deleteDriverTaxi: ", error.message);
      return false;
    }
  },
};

const getters = {
  taxis(state) {
    return state.taxis;
  },

  taxiById(state) {
    return state.taxiById;
  },

  driversTaxiById(state) {
    return state.driversTaxiById;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
